import _ from 'lodash';
import AppDispatcher from '../dispatcher/AppDispatcher';
import { ActionTypes, CONSENTS, GlobalModals } from '../constants/AppConstants';
import CustomerActions from './CustomerActions';
import ConsentsService from '../services/ConsentsService';
import ModalActions from './ModalActions';

const ConsentsActions = {
    async getConsentsTemplate() {
        _.defer(() =>
            AppDispatcher.dispatch({
                actionType: ActionTypes.GET_CONSENTS_TEMPLATE_STARTED,
            }),
        );
        try {
            const consents = await ConsentsService.getConsentsTemplate();
            _.defer(() =>
                AppDispatcher.dispatch({
                    actionType: ActionTypes.GET_CONSENTS_TEMPLATE_SUCCESS,
                    consents,
                }),
            );
            return consents;
        } catch (error) {
            _.defer(() =>
                AppDispatcher.dispatch({
                    actionType: ActionTypes.GET_CONSENTS_TEMPLATE_FAILED,
                    error,
                }),
            );
            ModalActions.open(GlobalModals.ERROR, { message: 'preference-centre.get-consents.error'});
            return null;
        } finally {
            _.defer(() =>
                AppDispatcher.dispatch({
                    actionType: ActionTypes.GET_CONSENTS_TEMPLATE_FINISHED,
                }),
            );
        }
    },

    async getConsents() {
        _.defer(() =>
            AppDispatcher.dispatch({
                actionType: ActionTypes.GET_USER_CONSENTS_STARTED,
            }),
        );
        try {
            const consents = await ConsentsService.getConsents();
            _.defer(() =>
                AppDispatcher.dispatch({
                    actionType: ActionTypes.GET_USER_CONSENTS_SUCCESS,
                    consents,
                }),
            );
            return consents;
        } catch (error) {
            _.defer(() =>
                AppDispatcher.dispatch({
                    actionType: ActionTypes.GET_USER_CONSENTS_FAILED,
                    error,
                }),
            );
            ModalActions.open(GlobalModals.ERROR, { message: 'preference-centre.get-consents.error'});
            return null;
        } finally {
            _.defer(() =>
                AppDispatcher.dispatch({
                    actionType: ActionTypes.GET_USER_CONSENTS_FINISHED,
                }),
            );
        }
    },

    async updateConsents(payload) {
        _.defer(() =>
            AppDispatcher.dispatch({
                actionType: ActionTypes.UPDATE_USER_CONSENTS_STARTED,
            }),
        );
        try {
            const consents = await ConsentsService.updateConsents(payload);
            _.defer(() =>
                AppDispatcher.dispatch({
                    actionType: ActionTypes.UPDATE_USER_CONSENTS_SUCCESS,
                    consents,
                }),
            );
            return consents;
        } catch (error) {
            _.defer(() =>
                AppDispatcher.dispatch({
                    actionType: ActionTypes.UPDATE_USER_CONSENTS_FAILED,
                    error,
                }),
            );
            ModalActions.open(GlobalModals.ERROR, { message: 'preference-centre.update-consents.error'});
            return null;
        } finally {
            _.defer(() =>
                AppDispatcher.dispatch({
                    actionType: ActionTypes.UPDATE_USER_CONSENTS_FINISHED,
                }),
            );
        }
    },

    async updateConsentsAndUser({ form, user }) {
        await this.updateConsents(form.normalizeSaveConsents());
        const userChanges = {};
        if (
            form.get(CONSENTS.SMS_Marketing) &&
            form.get(CONSENTS.PHONE) &&
            form.get(CONSENTS.PHONE) !== (user && user.telephoneNumber)
        ) {
            userChanges.telephoneNumber = form.get(CONSENTS.PHONE);
        }
        if (form.get(CONSENTS.OVER_16) !== user.isOver16) {
            userChanges.isOver16 = form.get(CONSENTS.OVER_16);
        }
        if (!_.isEmpty(userChanges)) {
            await CustomerActions.updateAuthenticatedProperties({
                user,
                currentPassword: null,
                changes: userChanges,
                requireAuth: false,
            });
        }
    },

    setConsentsForm(payload) {
        _.defer(() =>
            AppDispatcher.dispatch({
                actionType: ActionTypes.SET_CONSENTS_FORM,
                payload,
            }),
        );
    },
};

export default ConsentsActions;



// WEBPACK FOOTER //
// ./src/actions/ConsentsActions.js